import { memo } from 'react'
import { Button } from '@mui/material'

/**
 * GhostButton component - Reusable ghost/outlined button with consistent styling
 */
export const GhostButton = memo(({ children, ...props }) => {
  return (
    <Button
      variant="outlined"
      sx={{
        borderWidth: 2,
        '&:hover': {
          borderWidth: 2,
          bgcolor: 'rgba(99, 102, 241, 0.08)',
        },
        ...props.sx,
      }}
      {...props}
    >
      {children}
    </Button>
  )
})
